import { useShigoSession } from '../../lib/useShigoSession';
import {
  hasAllShigoPermissions,
  hasAnyShigoPermission,
  hasShigoPermission,
  type ShigoPermission,
} from './permissions';

export function useShigoPermissions() {
  const { session } = useShigoSession();
  const permissions = session?.user.permissions ?? [];

  return {
    permissions,
    can: (permission: ShigoPermission) => hasShigoPermission(permissions, permission),
    canAny: (required: readonly ShigoPermission[]) => hasAnyShigoPermission(permissions, required),
    canAll: (required: readonly ShigoPermission[]) => hasAllShigoPermissions(permissions, required),
  };
}
